export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6282.89b0591c.jpg";